import { brandItem } from '../../types/brandSchema';
export const sortBrand = (a: brandItem, b: brandItem) => b?.ord - a?.ord;

export function sortBrandsBySort(a: { sort: number }, b: { sort: number }) {
  if (a.sort < b.sort) {
    return 1;
  }
  if (a.sort > b.sort) {
    return -1;
  }
  return 0;
}
export function sortBrandsAlphabetize(a: { title: string }, b: { title: string }) {
  if (a.title < b.title) {
    return -1;
  }
  if (a.title > b.title) {
    return 1;
  }
  return 0;
}

export function sortBrandsChecked(a: { checked: boolean }, b: { checked: boolean }) {
  if (a.checked && !b.checked) {
    return -1;
  }
  if (!a.checked && b.checked) {
    return 1;
  }
  return 0;
}
export const sortBrandName = (a: brandItem, b: brandItem) => (a?.name < b?.name ? -1 : 1);
